import PropTypes from 'prop-types';

import { Processors } from '../../../constants';
import { CommonPaymentElementPropTypes } from '../../../propTypes';

export const FieldConfigurationProps = {
  required: PropTypes.bool,
};

export const BillingDetailsConfigurationPropTypes = {
  billingAddress1: PropTypes.shape(FieldConfigurationProps),
  billingAddress2: PropTypes.shape(FieldConfigurationProps),
  billingState: PropTypes.shape(FieldConfigurationProps),
  billingCity: PropTypes.shape(FieldConfigurationProps),
  billingZip: PropTypes.shape(FieldConfigurationProps),
  billingCountry: PropTypes.shape(FieldConfigurationProps),
  billingEmail: PropTypes.shape(FieldConfigurationProps),
  billingFirstName: PropTypes.shape(FieldConfigurationProps),
  billingLastName: PropTypes.shape(FieldConfigurationProps),
  billingName: PropTypes.shape(FieldConfigurationProps),
  billingBirthday: PropTypes.shape(FieldConfigurationProps),
  billingDocumentNumber: PropTypes.shape(FieldConfigurationProps),
  billingDocumentType: PropTypes.shape(FieldConfigurationProps),
  billingTaxId: PropTypes.shape(FieldConfigurationProps),
  billingCompany: PropTypes.shape(FieldConfigurationProps),
  billingPhone: PropTypes.shape(FieldConfigurationProps),
  billingFax: PropTypes.shape(FieldConfigurationProps),
};

export const ContactInformationConfigurationPropTypes = {
  firstName: PropTypes.shape(FieldConfigurationProps),
  lastName: PropTypes.shape(FieldConfigurationProps),
};

export const CreditCardPropTypes = {
  processor: PropTypes.oneOf(Processors).isRequired,
  billingConfig: PropTypes.shape(BillingDetailsConfigurationPropTypes),
  contactInformationConfig: PropTypes.shape(ContactInformationConfigurationPropTypes),
};

export const CreditCardFormPropTypes = {
  ...CommonPaymentElementPropTypes,
  ...CreditCardPropTypes,
};
